import React, { useEffect } from 'react';
import './TemplateGallery.css';

const templates = [
  {
    id: 'pro',
    name: 'Professional',
    description: 'Clean, traditional single-column layout ideal for corporate and conservative industries.',
    color: '#2563eb'
  },
  {
    id: 'modern',
    name: 'Modern',
    description: 'Gradient header with colored sidebar accents, perfect for tech and creative roles.',
    color: '#06b6d4'
  },
  {
    id: 'minimal',
    name: 'Minimal',
    description: 'Serif-based minimal design with plenty of whitespace and a literary feel.',
    color: '#1e293b'
  }
];

const TemplateGallery = ({ current, onSelect, onClose }) => {
  useEffect(() => {
    const handleKeyDown = (e) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [onClose]);

  return (
  <div className="modal-overlay" onClick={onClose}>
    <div className="template-gallery" onClick={(e) => e.stopPropagation()}>
      <div className="gallery-header">
        <h2>Choose a Template</h2>
        <button className="gallery-close" onClick={onClose}>×</button>
      </div>
      <div className="gallery-grid">
        {templates.map(tpl => (
          <div
            key={tpl.id}
            className={`template-card ${current === tpl.id ? 'selected' : ''}`}
            onClick={() => onSelect(tpl.id)}
          >
            <div className="template-preview" style={{ borderTop: `4px solid ${tpl.color}` }}>
              <div className="template-preview-header">
                <div className="preview-line preview-line-lg" />
                <div className="preview-line preview-line-sm" />
              </div>
              <div className="template-preview-body">
                <div className="preview-section-preview">
                  <div className="preview-line preview-line-title" />
                  <div className="preview-line preview-line-md" />
                  <div className="preview-line preview-line-md" />
                </div>
                <div className="preview-section-preview">
                  <div className="preview-line preview-line-title" />
                  <div className="preview-line preview-line-md" />
                </div>
                <div className="preview-section-preview">
                  <div className="preview-line preview-line-title" />
                  <div className="preview-line preview-line-sm" />
                  <div className="preview-line preview-line-sm" style={{ width: '60%' }} />
                </div>
              </div>
              {current === tpl.id && <div className="selected-badge">Active</div>}
            </div>
            <div className="template-info">
              <h3>{tpl.name}</h3>
              <p>{tpl.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  </div>
  );
};

export default TemplateGallery;
